import { User } from '@ms/yammer-data/dist/state/types';

import { GetBaseUrlProps, getBaseUrl } from '../location/getBaseUrl';

export const userSortByKey = 'sortBy';
export const userAchievementTypeQueryKey = 'type';
export const userAchievementLevelQueryKey = 'level';
export const userAchievementPathQueryKey = 'path';
export const userAchievementCountQueryKey = 'count';

export const userIdParam = ':userId';
export const userPageBasePath = '/users';
export const userParentSubpath = '/:userId';
export const userParentPath: `${typeof userPageBasePath}${typeof userParentSubpath}` = `${userPageBasePath}${userParentSubpath}`;

const replaceUserId = (path: string, userId: User['id']) => path.replace(userIdParam, userId);

export const userPage = (userId: User['id']) => replaceUserId(userParentPath, userId);

export const userStorylineSubpath = '/storyline';
export const userStorylinePath: `${typeof userParentPath}${typeof userStorylineSubpath}` = `${userParentPath}${userStorylineSubpath}`;
export const userStorylinePage = (userId: User['id']) => replaceUserId(userStorylinePath, userId);

export const userStorylinePublisherSubpath = '/storyline-publisher';
export const userStorylinePublisherPath: `${typeof userParentPath}${typeof userStorylinePublisherSubpath}` = `${userParentPath}${userStorylinePublisherSubpath}`;
export const userStorylinePublisherPage = (userId: User['id']) => replaceUserId(userStorylinePublisherPath, userId);

export const userAudienceFeedSubpath = '/audiencefeed';
export const userAudienceFeedPath: `${typeof userParentPath}${typeof userAudienceFeedSubpath}` = `${userParentPath}${userAudienceFeedSubpath}`;
export const userAudienceFeedPage = (userId: User['id']) => replaceUserId(userAudienceFeedPath, userId);

export const userMyBookmarksSubpath = '/bookmarks';
export const userMyBookmarksPath: `${typeof userParentPath}${typeof userMyBookmarksSubpath}` = `${userParentPath}${userMyBookmarksSubpath}`;
export const userMyBookmarksPage = (userId: User['id']) => replaceUserId(userMyBookmarksPath, userId);

export const userPendingPostsSubpath = '/pending-posts';
export const userPendingPostsPath: `${typeof userParentPath}${typeof userPendingPostsSubpath}` = `${userParentPath}${userPendingPostsSubpath}`;
export const userPendingPostsPage = (userId: User['id']) => replaceUserId(userPendingPostsPath, userId);

export const userMyDraftsSubpath = '/drafts';
export const userMyDraftsPath: `${typeof userPendingPostsPath}${typeof userMyDraftsSubpath}` = `${userPendingPostsPath}${userMyDraftsSubpath}`;
export const userMyDraftsPage = (userId: User['id']) => replaceUserId(userMyDraftsPath, userId);

export const userScheduledPostsSubpath = '/scheduled';
export const userScheduledPostsPath: `${typeof userPendingPostsPath}${typeof userScheduledPostsSubpath}` = `${userPendingPostsPath}${userScheduledPostsSubpath}`;
export const userScheduledPostsPage = (userId: User['id']) => replaceUserId(userScheduledPostsPath, userId);

type UserPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userPageUrl: UserPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userPage(userId)}`;
};

type UserStorylinePageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userStorylinePageUrl: UserStorylinePageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userStorylinePage(userId)}`;
};

type UserMyBookmarksPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userMyBookmarksPageUrl: UserMyBookmarksPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userMyBookmarksPage(userId)}`;
};

export type UserPendingPostsType = 'Drafts' | 'Scheduled';

type UserPendingPostsPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userPendingPostsPageUrl: UserPendingPostsPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userPendingPostsPage(userId)}`;
};

type UserMyDraftsPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userMyDraftsPageUrl: UserMyDraftsPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userMyDraftsPage(userId)}`;
};

type UserScheduledPostsPageUrl = (userId: User['id'], host: GetBaseUrlProps['host']) => string;
export const userScheduledPostsPageUrl: UserScheduledPostsPageUrl = (userId, host) => {
  const baseUrl = getBaseUrl({ host });

  return `${baseUrl}${userScheduledPostsPage(userId)}`;
};

type OfficeUserStorylinePublisherPage = (officeUserId: User['officeUserId']) => string;
export const storylinePublisherPageByOfficeUserId: OfficeUserStorylinePublisherPage = (officeUserId) =>
  `/officeusers/${officeUserId}/storyline-publisher?publisherOpen=true`;
